import { Grid, Typography } from "@mui/material"
import type { orderItem as OrderItemType } from './VerificationType'

type configType = {
  inbound_number: string
}

const labelStyle = { color: '#7A97B0', fontSize: '14px!important', fontWeight: 400 }
const valueStyle = { fontWeight: 500, fontSize: '14px!important', color: '#242424' }

const BusinessIntroConfig = ({ orderItem }: { orderItem: OrderItemType }) => {
  const config: configType = orderItem.config

  return <Grid container spacing={1.5}>
    <Grid item sm={4}>
      <Typography sx={labelStyle}>Attach to number</Typography>
      <Typography sx={valueStyle}>{config.inbound_number}</Typography>
    </Grid>
  </Grid>
}

export default BusinessIntroConfig
